import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: false,
  documenti: [],
};

const documentiSlice = createSlice({
  name: 'documenti',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = !!action.payload;
    },
    aggiornaDocumenti(state, action) {
      state.documenti = action.payload;
    },
  },
});

export const { caricamento, aggiornaDocumenti } = documentiSlice.actions;
const documentiReducer = documentiSlice.reducer;

export default documentiReducer;
